import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/face_love_blue.svg'


const _withScopeId = n => (_pushScopeId("data-v-3e36b880"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "face_love_bar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "me-1",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "fev_text5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.text), 1)
  ]))
}